/* Conscomer — Descripción de producto con Leer más / Leer menos */
(function () {
  'use strict';

  if (window.descripcionProductoLoaded) return;
  window.descripcionProductoLoaded = true;

  var TEXTO_MAS = 'Leer más';
  var TEXTO_MENOS = 'Leer menos';

  function setup(container) {
    if (container.dataset.descripcionReady === 'true') return;
    container.dataset.descripcionReady = 'true';

    var contenido = container.querySelector('[data-descripcion-contenido]');
    var toggle = container.querySelector('[data-descripcion-toggle]');
    var toggleTexto = container.querySelector('[data-descripcion-toggle-texto]');

    if (!contenido || !toggle || !toggleTexto) return;

    var hijos = Array.prototype.slice.call(contenido.children);
    if (!hijos.length) return;

    /* Encontrar el primer párrafo real (primer <p> con texto) */
    var indicePrimerParrafo = -1;
    for (var i = 0; i < hijos.length; i++) {
      if (hijos[i].tagName === 'P' && hijos[i].textContent.trim() !== '') {
        indicePrimerParrafo = i;
        break;
      }
    }

    /* Si no hay párrafos, no recortamos: se muestra todo */
    if (indicePrimerParrafo === -1) return;

    /* Marcar como oculto todo lo que venga DESPUÉS del primer párrafo */
    var hayOcultos = false;
    for (var j = indicePrimerParrafo + 1; j < hijos.length; j++) {
      hijos[j].classList.add('descripcion-producto__oculto');
      hayOcultos = true;
    }

    /* Si no queda nada oculto, no hace falta el botón */
    if (!hayOcultos) return;

    contenido.setAttribute('data-colapsado', 'true');
    toggle.hidden = false;

    toggle.addEventListener('click', function () {
      var colapsado = contenido.getAttribute('data-colapsado') === 'true';
      if (colapsado) {
        contenido.setAttribute('data-colapsado', 'false');
        toggle.setAttribute('aria-expanded', 'true');
        toggleTexto.textContent = TEXTO_MENOS;
      } else {
        contenido.setAttribute('data-colapsado', 'true');
        toggle.setAttribute('aria-expanded', 'false');
        toggleTexto.textContent = TEXTO_MAS;
      }
    });
  }

  function init(scope) {
    var root = scope && scope.querySelectorAll ? scope : document;
    var nodes = root.querySelectorAll('[data-descripcion-producto]');
    Array.prototype.forEach.call(nodes, setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target || document);
  });
})();